import React from "react";
import { ReactSVG } from "react-svg";

type Props = {
    imageUrl: string;
};

export const GradeImageChart = (props: Props) => {
    const { imageUrl } = props;

    return (
        <ReactSVG
            className="col-12 lg:col-8 grade-image-chart "
            src={imageUrl}
        />
    );
};
